<template lang="pug">
.v-leasing-form-leasing-data
	fieldset
		legend.sf-heading-2 Lízing adatok
		.form-row(v-if="!personalLeasing")
			.form-col
				.label-tooltip-wrapper
					label(aria-hidden="true") Lízing típusa
					VueTooltip(placement="bottom")
						p(slot="content") Zártvégű pénzügyi lízing esetén a teljes tartozás megfizetését követően automatikusan az ügyfél tulajdonába kerül a gépjármű.
							br
							| Nyíltvégű pénzügyi lízing esetén az ügyfélnek a futamidő végén nyilatkoznia kell, hogy a maradványértéken megvásárolja a gépjárművet vagy kijelöl egy harmadik személyt vásárlónak vagy nem kíván élni opciós jogával. Nyíltvégű pénzügyi lízing esetén a havi lízingdíj nettó érték, amelynek tőke részét további 27% ÁFA fizetés terheli, viszont az ÁFA a céges használat arányában visszaigényelhető.
			.form-col
				VueRadioGroup(v-model="model.leasingType", legend="Lízing típusa", :isLegendHidden="true", :mobileInline="true", :options="leasingType")
		.form-row(v-if="openEnterpriseLeasing")
			.form-col
				label(for="vl-netSellPrice") Nettó vételár
			.form-col
				VueCurrencyInput#vl-netSellPrice(v-model="model.netSellPrice", aria-describedby="vl-netSellPrice-err", :max-width="176", postfix="Ft", :has-error="$v.model.netSellPrice.$dirty && $v.model.netSellPrice.$invalid", @blur="$v.model.netSellPrice.$touch(); onNetSellChange()")
				VueErrorMessage#vl-netSellPrice-err(v-if="$v.model.netSellPrice.$dirty && !$v.model.netSellPrice.required", position="bottom") Kérjük, adja meg a nettó vételár összegét!
		.form-row(v-if="openEnterpriseLeasing")
			.form-col
				label(for="vl-vat") ÁFA összege
			.form-col
				VueCurrencyInput#vl-vat(v-model="model.vat", aria-describedby="vl-vat-err", :max-width="176", postfix="Ft", :has-error="$v.model.vat.$dirty && $v.model.vat.$invalid", @blur="$v.model.vat.$touch(); onVatChange()")
				VueErrorMessage#vl-vat-err(v-if="$v.model.vat.$dirty && !$v.model.vat.required", position="bottom") Kérjük, adja meg az ÁFA összegét!
		.form-row(v-if="openEnterpriseLeasing && (model.vehicleUsed == 'Y' || (model.vehicleUsed == 'N' && model.vehicleSource == VEHICLE_SOURCE.HOME))")
			.form-col
				.label-tooltip-wrapper
					label(for="vl-regTax") Regisztrációs adó
					VueTooltip(placement="bottom")
						p(slot="content") Új hazai valamint külföldről importált gépjárművek esetén regisztrációs adót is kell fizetnie.
			.form-col
				VueCurrencyInput#vl-regTax(v-model="model.registrationTax", :max-width="176", postfix="Ft", :disabled="isHomeUsed", :has-error="$v.model.registrationTax.$dirty && $v.model.registrationTax.$invalid", @blur="$v.model.registrationTax.$touch(); onRegistrationTaxChange()", aria-describedby="vl-regTax-err")
				VueErrorMessage#vl-regTax-err(v-if="$v.model.registrationTax.$dirty && $v.model.registrationTax.$invalid && !$v.model.registrationTax.required", position="bottom") Kérjük, adja meg az regisztrációs adó összegét!
				VueErrorMessage#vl-regTax-err(v-if="$v.model.registrationTax.$dirty && $v.model.registrationTax.$invalid && $v.model.registrationTax.required && !$v.model.registrationTax.numeric", position="bottom") Kérjük, ellenőrizze a megadott regisztrációs adó összeget!
		.form-row
			.form-col
				label(for="vl-grossSellPrice") {{ personalLeasing ? 'Vételár' : 'Bruttó vételár' }}
			.form-col
				VueCurrencyInput#vl-grossSellPrice(v-model="model.grossSellPrice", aria-describedby="vl-grossSellPrice-err", postfix="Ft", :max-width="176", :has-error="$v.model.grossSellPrice.$dirty && $v.model.grossSellPrice.$invalid", @blur="$v.model.grossSellPrice.$touch(); onGrossSellChange()")
				VueErrorMessage#vl-grossSellPrice-err(v-if="$v.model.grossSellPrice.$dirty && !$v.model.grossSellPrice.required", position="bottom") Kérjük, adja meg a {{ !personalLeasing ? 'bruttó' : '' }} vételárat!

		.form-row
			.form-col
				label(for="vl-ownContributionPercent") {{ openEnterpriseLeasing ? 'Nettó önerő' : 'Önerő' }}
			.form-col.selectable-percent-value
				VueSelect#vl-ownContributionPercent(:max-width="120", label-id="vl-ownContributionPercent", v-model="ownContributionPercent", placeholder="Válassz", :has-error="(!$v.model.dateOfManufacture.$invalid && hasFormError('ageOfVehicleEndOfFinancing')) || hasFormError('model.ownContribution')", @input="$v.ageOfVehicleEndOfFinancing.$touch()")
					VueSelectOption(v-for="(item, index) in ownContributionPercents", :value="item.key", :text="item.value", :index="index", label-id="label1", :key="item.key")
				span.percentage %
				VueCurrencyInput#vl-ownContribution(v-model="model.ownContribution", aria-describedby="vl-ownContribution-err", :max-width="176", postfix="Ft", :has-error="hasFormError('model.ownContribution')", :addon="hasOwnContributionAddon ? `Minimum 20% (${$options.filters.currency(minOwnContribution, 'HUF')} Ft)` : ''", @blur="validateField('model.ownContribution', 'financedPrice')")
				VueErrorMessage#vl-ownContribution-err(v-if="hasFormError('model.ownContribution', 'required')", position="bottom") Kérjük, adja meg az önerő összegét!
				VueErrorMessage#vl-ownContribution-err(v-if="hasFormError('model.ownContribution', 'between')", position="bottom") Kérjük, ellenőrizze a megadott önerő összegét!
		.form-row
			.form-col
				label(for="vl-financedPrice") Finanszírozott összeg
			.form-col
				VueCurrencyInput#vl-financedPrice(:value="financedPrice", :max-width="176", postfix="Ft", :has-error="hasFormError('financedPrice')", readonly="true", aria-describedby="vl-financedPrice-err")
				VueErrorMessage#vl-financedPrice-err(v-if="hasFormError('financedPrice', 'minValue')", position="bottom") A finanszírozott összeg minimuma {{ minFinancedPriceText }} Ft, kérjük, változtassa az önerő összegét!
				VueErrorMessage#vl-financedPrice-err(v-if="hasFormError('financedPrice', 'maxValue')", position="bottom") A finanszírozott összeg maximuma {{ maxFinancedPriceText }} Ft, kérjük, változtassa az önerő összegét!

		.form-row
			.form-col
				label#vl-personalPeriodNumber-lbl(for="vl-personalPeriodNumber") Futamidő
			.form-col
				VueSelect#vl-personalPeriodNumber(:max-width="176", label-id="vl-personalPeriodNumber-lbl", v-model="model.periodNumber", placeholder="Válassz", :has-error="!$v.model.dateOfManufacture.$invalid && $v.ageOfVehicleEndOfFinancing.$dirty && $v.ageOfVehicleEndOfFinancing.$invalid", @input="$v.ageOfVehicleEndOfFinancing.$touch()", aria-describedby="vl-ageOfVehicleEndOfFinancing-err")
					VueSelectOption(v-for="(item, index) in periodNumber", :value="item.key", :text="item.value", :index="index", label-id="label1", :key="item.key")
				VueErrorMessage#vl-ageOfVehicleEndOfFinancing-err(v-if="!$v.model.dateOfManufacture.$invalid && $v.ageOfVehicleEndOfFinancing.$dirty && !$v.ageOfVehicleEndOfFinancing.maxValue", position="bottom") A gépjármű életkora a finanszírozás végén max. {{ vehicleAgeEndOfFinancingLimit }} év lehet, kérjük, válasszon rövidebb futamidőt!
		.form-row(v-if="openEnterpriseLeasing")
			.form-col
				.label-tooltip-wrapper
					label(for="vl-restAmountPercent") Nettó maradványérték
					VueTooltip(placement="bottom")
						p(slot="content") 
							| Nyíltvégű lízing esetén a gépjárművet a futamidő végén a maradványérték megfizetésével vásárolhatja meg.
							br 
							| Minimum és maximum értéke függ a gépjármű bruttó vételárától és a választott futamidő hosszától.
			.form-col.selectable-percent-value
				VueSelect#vl-restAmountPercent(:max-width="120", v-model="model.restAmountPercent", placeholder="Válassz", @input="$v.model.restAmountPercent.$touch()", aria-describedby="vl-restAmount-err")
					VueSelectOption(v-for="(item, index) in restAmountPercentRange", :value="item.key", :text="item.value", :index="index", label-id="label1", :key="uniquePercentKey + item.key")
				span.percentage %
				span.amount-in-huf(v-if="restAmount") {{ restAmount }} Ft
				VueErrorMessage#vl-restAmount-err(v-if="$v.model.restAmountPercent.$dirty && !$v.model.restAmountPercent.required", position="bottom") Kérjük, adja meg az nettó maradványérték százalékot!
</template>
<script>
import VueInput from '@ui-common/vue-input';
import VueCurrencyInput from '@ui-common/vue-currency-input';
import VueRadioGroup from '@ui-common/vue-radio-group';
import VueTooltip from '@ui-common/vue-tooltip';
import VueErrorMessage from '@ui-common/vue-error-message';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import { VAT_RATE, REST_AMOUNT_MIN_MAX, VEHICLE_SOURCE, VEHICLE_DESIGNATION } from '../../constants';
const notEmpty = val => val !== null && val !== '';
export default {
	data: () => ({
		restAmountPercent: null,
		ownContributionPercent: null,
		uniquePercentKey: new Date().getTime()
	}),
	inject: ['$v', 'hasFormError', 'validateField'],
	props: {
		model: {
			required: true
		},
		debtorType: {
			required: true
		},
		leasingType: {
			type: Array,
			required: false
		},
		personalLeasing: {
			type: Boolean,
			required: false
		},
		enterpriseLeasing: {
			type: Boolean,
			required: false
		},
		closedEnterpriseLeasing: {
			type: Boolean,
			required: false
		},
		openEnterpriseLeasing: {
			type: Boolean,
			required: false
		},
		minFinancedPrice: {
			type: Number,
			required: true
		},
		maxFinancedPrice: {
			type: Number,
			required: true
		},
		minOwnContribution: {
			type: Number,
			required: false
		},
		vehicleAgeEndOfFinancingLimit: {
			type: Number
		},
		vehicleSourceImport: {
			type: Boolean,
			required: true
		},
		financedPrice: {
			required: true
		},
		periodNumber: {
			required: true
		},
		financeTypes: {
			required: true
		},
		ownContributionPercents: {
			required: true
		}
	},
	components: {
		VueInput,
		VueCurrencyInput,
		VueSelect,
		VueTooltip,
		VueSelectOption,
		VueRadioGroup,
		VueErrorMessage
	},
	watch: {
		'model.vehicleSource': {
			handler(val) {
				this.ownContributionPercent = null;
			},
			immediate: true
		},
		'model.vehicleUsed': {
			handler(val) {
				this.ownContributionPercent = null;
			},
			immediate: true
		},
		ownContributionPercent(val) {
			if (val) {
				if (this.personalLeasing || !this.openEnterpriseLeasing) {
					this.model.ownContribution = Math.ceil((this.model.grossSellPrice * this.ownContributionPercent) / 100);
				} else {
					this.model.ownContribution = this.enterpriseLeasingOwnContribution;
				}
				this.validateField('model.ownContribution', 'financedPrice');
			}
		},
		restAmountPercentRange(val) {
			this.model.restAmountPercent = null;
			this.uniquePercentKey = new Date().getTime();
		},
		'model.grossSellPrice'(val) {
			if (this.ownContributionPercent) {
				if (this.personalLeasing || !this.openEnterpriseLeasing) {
					this.model.ownContribution = Math.round((this.model.grossSellPrice * this.ownContributionPercent) / 100);
				} else {
					this.model.ownContribution = this.enterpriseLeasingOwnContribution;
				}
			} else if (!this.ownContributionPercent && this.model.grossSellPrice < this.minOwnContribution) {
				this.model.ownContribution = null;
			}
		},
		'model.netSellPrice'(val) {
			if (this.ownContributionPercent) {
				if (!(this.personalLeasing || !this.openEnterpriseLeasing)) {
					this.model.ownContribution = this.enterpriseLeasingOwnContribution;
				}
			} else if (!this.ownContributionPercent && this.model.grossSellPrice < this.minOwnContribution) {
				this.model.ownContribution = null;
			}
		}
	},
	computed: {
		VEHICLE_SOURCE: () => VEHICLE_SOURCE,
		minRestAmountPercent() {
			const ltSixMillion = this.model.grossSellPrice < 12000000;
			return (ltSixMillion ? REST_AMOUNT_MIN_MAX.LT_TWELVE_MILLION : REST_AMOUNT_MIN_MAX.GE_TWELVE_MILLION)[this.model.periodNumber].MIN * 100;
		},
		maxRestAmountPercent() {
			const ltSixMillion = this.model.grossSellPrice < 12000000;
			return (ltSixMillion ? REST_AMOUNT_MIN_MAX.LT_TWELVE_MILLION : REST_AMOUNT_MIN_MAX.GE_TWELVE_MILLION)[this.model.periodNumber].MAX * 100;
		},

		restAmountPercentRange() {
			let range = [];
			for (let i = this.minRestAmountPercent; i <= this.maxRestAmountPercent; i++) {
				range.push(i);
			}
			return range.map(item => ({ key: item, value: item }));
		},
		minFinancedPriceText() {
			return this.numberToText(this.minFinancedPrice);
		},
		maxFinancedPriceText() {
			return this.numberToText(this.maxFinancedPrice);
		},
		restAmount() {
			return this.$options.filters.currency(((this.model.netSellPrice + this.model.registrationTax) * this.model.restAmountPercent) / 100, 'HUF');
		},
		hasOwnContributionAddon() {
			return (
				((this.personalLeasing || this.losedEnterpriseLeasing) && this.model.grossSellPrice) ||
				(this.openEnterpriseLeasing && this.model.grossSellPrice)
			);
		},
		enterpriseLeasingOwnContribution() {
			return Math.ceil(((this.model.netSellPrice + this.model.registrationTax) * this.ownContributionPercent) / 100);
		},
		isHomeUsed() {
			return this.model.vehicleUsed == 'Y' && this.model.vehicleSource == VEHICLE_SOURCE.HOME;
		}
	},
	methods: {
		onGrossSellChange() {
			if (notEmpty(this.model.grossSellPrice)) {
				if (notEmpty(this.model.registrationTax)) {
					this.model.netSellPrice = Math.round((this.model.grossSellPrice - this.model.registrationTax) / ((VAT_RATE + 100) / 100));
					this.model.vat = this.model.grossSellPrice - this.model.netSellPrice - this.model.registrationTax;
				} else if (notEmpty(this.model.vat)) {
					this.model.netSellPrice = (this.model.vat / VAT_RATE) * 100;
					this.model.vat = Math.round(this.model.netSellPrice * (VAT_RATE / 100));
					if (!this.isHomeUsed) {
						this.model.registrationTax = this.model.grossSellPrice - this.model.netSellPrice - this.model.vat;
					}
				} else if (notEmpty(this.model.netSellPrice)) {
					this.model.vat = Math.round(this.model.netSellPrice * (VAT_RATE / 100));
					if (!this.isHomeUsed) {
						this.model.registrationTax = this.model.grossSellPrice - this.model.vat - this.model.netSellPrice;
					}
				}
			}
		},
		onNetSellChange() {
			if (notEmpty(this.model.netSellPrice)) {
				this.model.vat = Math.round(this.model.netSellPrice * (VAT_RATE / 100));
				if (notEmpty(this.model.registrationTax)) {
					this.model.grossSellPrice = this.model.netSellPrice + this.model.vat + this.model.registrationTax;
				} else if (notEmpty(this.model.grossSellPrice) && !this.isHomeUsed) {
					this.model.registrationTax = this.model.grossSellPrice - this.model.vat - this.model.netSellPrice;
				}
			}
		},
		onVatChange() {
			if (notEmpty(this.model.vat)) {
				if (notEmpty(this.model.registrationTax)) {
					this.model.netSellPrice = Math.round((this.model.vat / VAT_RATE) * 100);
					this.model.grossSellPrice = this.model.netSellPrice + this.model.vat + this.model.registrationTax;
				} else if (notEmpty(this.model.grossSellPrice)) {
					this.model.netSellPrice = Math.round((this.model.vat / VAT_RATE) * 100);
					if (!this.isHomeUsed) {
						this.model.registrationTax = this.model.grossSellPrice - this.model.vat - this.model.netSellPrice;
					}
				}
			}
		},
		onRegistrationTaxChange() {
			if (notEmpty(this.model.registrationTax)) {
				if (notEmpty(this.model.netSellPrice)) {
					this.model.vat = Math.round(this.model.netSellPrice * (VAT_RATE / 100));
					this.model.grossSellPrice = this.model.netSellPrice + this.model.vat + this.model.registrationTax;
				} else if (notEmpty(this.model.grossSellPrice)) {
					this.model.netSellPrice = Math.round((this.model.grossSellPrice - this.model.registrationTax) / ((VAT_RATE + 100) / 100));
					this.model.vat = this.model.grossSellPrice - this.model.netSellPrice - this.model.registrationTax;
				} else if (notEmpty(this.model.vat)) {
					this.model.netSellPrice = (this.model.vat / VAT_RATE) * 100;
					this.model.vat = Math.round(this.model.netSellPrice * (VAT_RATE / 100));
					this.model.grossSellPrice = this.model.netSellPrice + this.model.vat + this.model.registrationTax;
				}
			}
		},
		numberToText(val) {
			if (val) {
				if (val % 1000000 == 0) {
					return val / 1000000 + ' millió';
				} else {
					return this.$options.filters.currency(val, 'HUF');
				}
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import '@ui-common/sf-style-utils/lib/helpers/_colors.scss';
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.v-leasing-form-leasing-data {
	margin-bottom: 32px;
}

.v-leasing-form-leasing-data .form-col.selectable-percent-value {
	display: flex;
	flex-wrap: wrap;
}

.v-leasing-form-leasing-data .form-row .form-col.selectable-percent-value .percentage {
	@include media('<tablet') {
		margin-bottom: 8px;
	}
}

.v-leasing-form-leasing-data .form-col.selectable-percent-value .percentage,
.v-leasing-form-leasing-data .form-col.selectable-percent-value .amount-in-huf {
	font-weight: bold;
	line-height: 48px;
	margin: 0 8px;
}

.v-leasing-form-leasing-data .form-row .form-col ::v-deep .sf-error {
	z-index: 2;
}

.v-leasing-form-leasing-data ::v-deep .sf-select__button-wrapper::before {
	pointer-events: none;
}
</style>
